import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import Sidebar from "../organisms/layout/SideBar";
import { CHECK_SESSION } from "../../api/apiAuth";
import { useSession } from "../../context/SessionContext";

const Layout = ({ children }) => {
	const { setUser } = useSession();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const verify = async () => {
			try {
				console.log('🔍 Iniciando CHECK_SESSION...');
				const response = await CHECK_SESSION();
				console.log('✅ Response recibida:', response);
				setUser(response);
			} catch (error) {
				toast.error("Sesión no válida");
				navigate("/login");
			} finally {
				setLoading(false);
			}
		};

		verify();
	}, [navigate, setUser]);

	if (loading) return <div className="w-full h-screen flex items-center justify-center"> <PropagateLoader color="red" /> </div>;

	return (
		<div className="flex h-screen bg-gradient-to-b from-rs-azul/75 via-rs-azul/60 to-rs-azul/45 md:p-3 md:pb-0">
			<Sidebar />
			<div className="flex-grow flex flex-col bg-gray-200 md:rounded-md md:rounded-b-none">
				<main className="h-screen p-3 overflow-auto">{children}</main>
			</div>
		</div>
	);
};

export default Layout;